import { FC } from "react";
import { ShoppingBag } from "lucide-react";

export const FooterSection: FC = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-primary/90 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 text-3xl font-bold mb-4">
            <ShoppingBag className="w-10 h-10" />
            jual.in
          </div>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Platform gratis untuk membuat link produk dengan template pesan WhatsApp
          </p>
        </div>
        <div className="border-t border-white/10 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} jual.in - Semua Hak Dilindungi.</p>
        </div>
      </div>
    </footer>
  );
};